/* @flow */

import React from 'react';

type Props = {
  count: number,
};

const UploadCounter = ({ count }: Props) => (
  <div className="ui floating green circular label">
    {count}
  </div>
);

export default UploadCounter;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/components/UploadCounter.js